import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../context/LanguageContext';
import sound from '../audio/soundManager';

const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.4rem 1rem 1rem;
  background:
    linear-gradient(180deg, rgba(11, 16, 32, 0.92) 0%, rgba(11, 16, 32, 0.55) 100%);
  border-bottom: 1px solid var(--color-border-soft);
  position: relative;
  z-index: 100;
  font-family: var(--font-display);
  backdrop-filter: blur(6px);
`;

const Logo = styled.a`
  font-size: 2.2rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  color: var(--color-gold-soft);
  text-decoration: none;
  font-family: var(--font-display);
  text-shadow: 0 0 24px rgba(156, 107, 255, 0.45);
  transition: color var(--dur-base) var(--ease-soft), text-shadow var(--dur-base) var(--ease-soft);

  &:hover {
    color: var(--color-gold);
    text-shadow: 0 0 24px rgba(212, 175, 55, 0.55);
  }

  @media (max-width: 768px) {
    font-size: 1.7rem;
  }

  @media (max-width: 375px) {
    font-size: 1.4rem;
  }
`;

const SoundToggle = styled.button`
  position: absolute;
  top: 1.4rem;
  right: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.4rem;
  height: 2.4rem;
  font-size: 1.2rem;
  line-height: 1;
  background: transparent;
  color: var(--color-text-secondary);
  border: 1px solid var(--color-border-soft);
  border-radius: 50%;
  cursor: pointer;
  transition: color var(--dur-base) var(--ease-soft),
              background-color var(--dur-base) var(--ease-soft),
              border-color var(--dur-base) var(--ease-soft);

  &:hover, &:focus-visible {
    color: var(--color-gold-soft);
    background-color: var(--color-accent-violet-soft);
    border-color: var(--color-border-strong);
    outline: none;
  }

  @media (max-width: 375px) {
    width: 2.1rem;
    height: 2.1rem;
    font-size: 1.05rem;
  }
`;

const Header = () => {
  const [muted, setMutedState] = useState(() => sound.isMuted());
  const { t } = useLanguage();

  const toggleSound = useCallback(() => {
    setMutedState((prev) => {
      const next = !prev;
      sound.setMuted(next);
      if (!next) {
        sound.startAmbient();
      }
      return next;
    });
  }, []);

  return (
    <HeaderContainer>
      <Logo href="https://freetarot.cards/" target="_blank" rel="noopener noreferrer">✦ Tarot Cards Reading ✦</Logo>

      <SoundToggle
        type="button"
        onClick={toggleSound}
        aria-label={muted ? t('header.soundOn') : t('header.soundOff')}
        title={muted ? t('header.soundOn') : t('header.soundOff')}
      >
        {muted ? '🔇' : '🔊'}
      </SoundToggle>
    </HeaderContainer>
  );
};

export default Header;
